module.exports = __webpack_public_path__ + "static/media/PICK UP MOVIL-04.0e48a829.png";